// #region Dependencias
import styled from 'styled-components'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledTextError = styled.small`
  color: ${colors.error};
  display: block;
  font-size: 0.75rem;
  height: 15px;
  margin: 0 auto 0 0;
`
// #endregion

/**
 * Componente para renderizar un texto de error.
 *
 * @class
 * @example
 * <TextError error="Los campos no son validos" />
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.error=""] - Texto de error del componente.
 */
const TextError = ({ error = '', ...props }) => {
  return <StyledTextError {...props}>{error}</StyledTextError>
}

export default TextError
